// extracted by mini-css-extract-plugin
export default {"ScrollArrows":"ScrollArrows_ScrollArrows__asHzR","ArrowUp":"ScrollArrows_ArrowUp__Vi8uz","ArrowDown":"ScrollArrows_ArrowDown__ZEpST","Disabled":"ScrollArrows_Disabled__8feEm"};